import { Flex, Inline, OverlineText, Stack, Text } from "@hopper-ui/components";
import { AngleRightIcon, ShieldIcon } from "@hopper-ui/icons";
import type { ReactNode } from "react";

export interface OperationCardHeaderProps {
    title: string;
    icon?: ReactNode;
    isLink: boolean;
    isPolicy: boolean;
}

export function OperationCardHeader({ title, icon, isLink, isPolicy }: OperationCardHeaderProps) {
    const titleRow = (
        <Inline columnGap="inline-sm" alignY="center">
            {icon}
            <Text fontWeight="body-sm-semibold" color="neutral">
                {title}
            </Text>
        </Inline>
    );

    const policyTag = (
        <Inline columnGap="inline-xs" alignY="center">
            <ShieldIcon size="sm" />
            <OverlineText color="neutral-weak" data-public>
                Policy
            </OverlineText>
        </Inline>
    );

    return (
        <Stack gap="stack-sm">
            <Flex justifyContent="space-between" alignItems="center" gap="inline-sm">
                {isPolicy ? policyTag : titleRow}
                {isLink && <AngleRightIcon size="sm" />}
            </Flex>
            {isPolicy && titleRow}
        </Stack>
    );
}
